import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { post, fetch, put } from "./utils/requset";
import Antd from "ant-design-vue";
import ElementUI from "element-ui";
import qs from 'qs'
import "ant-design-vue/dist/antd.css";
import "element-ui/lib/theme-chalk/index.css";
import "./assets/css/init.scss";

import "./assets/font/iconfont.css";
import "./assets/font/iconfont.js";
import "./utils/prototypeHelper.js";
import "./utils/js.cookie.min.js";
import "./utils/jquery.js";
// 导入极验
require("./utils/gt.js");
// 绑定到原型
Vue.prototype.$initGeet = initGeetest;

import axios from "axios";
Vue.prototype.$axios = axios;

Vue.config.productionTip = false;
Vue.prototype.$post = post;
Vue.prototype.$fetch = fetch;
Vue.prototype.$put = put;
Vue.prototype.$qs = qs
Vue.use(Antd);
Vue.use(ElementUI);

console.log(process.env.NODE_ENV);
console.log(process.env.VUE_APP_BASE_API);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});
